import { render, staticRenderFns } from "./ThankYouConfirmation.vue?vue&type=template&id=48eed327&scoped=true&"
import script from "./ThankYouConfirmation.vue?vue&type=script&lang=js&"
export * from "./ThankYouConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouConfirmation.vue?vue&type=style&index=0&id=48eed327&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eed327",
  null
  
)

export default component.exports